import { getSortedAnalyticsPerformancePagesFromGroupPages } from 'app/modules/analytics/utils/profileGroupPageToPageData';
import type { ProfileGroup, ProfileGroupPage } from 'types/Page';

export function omitGlobalPagesFromProfileGroupPages(
  pages: ProfileGroupPage[],
): ProfileGroupPage[] {
  return pages.filter((page) => !page.isGlobal);
}

export function profileGroupEligibleForAnalyticsPicker(
  group: ProfileGroup | null | undefined,
): boolean {
  return (
    getSortedAnalyticsPerformancePagesFromGroupPages(group?.pages).length > 0
  );
}

export function profileGroupsEligibleForAnalyticsPicker(
  profileGroups: ProfileGroup[],
): ProfileGroup[] {
  return profileGroups.filter((group) =>
    profileGroupEligibleForAnalyticsPicker(group),
  );
}
